import { EditFilled } from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';

import { Button } from '../../../../components/index';

export function cargoTypeColumns(
  onSelectItem: (record: any) => void
): ColumnsType<Record<string, any>> {
  return [
    {
      title: 'Nome do tipo',
      dataIndex: 'description',
      sorter: {
        compare: (a: any, b: any) =>
          (a.description || '').localeCompare(b.description || ''),
        multiple: 1,
      },
      defaultSortOrder: 'ascend' as const,
      showSorterTooltip: false,
    },
    {
      title: 'Grupo de produto',
      dataIndex: ['product_group', 'name'],
      sorter: {
        compare: (a: any, b: any) =>
          (a.product_group?.name || '').localeCompare(
            b.product_group?.name || ''
          ),
        multiple: 1,
      },
      showSorterTooltip: false,
    },
    {
      title: 'Natureza da carga',
      dataIndex: ['product_group', 'nature_of_cargo', 'name'],
      showSorterTooltip: false,
    },
    {
      dataIndex: 'edit',
      align: 'center' as const,
      width: '10%',
      render: (_: any, record: any) => (
        <Button
          icon={<EditFilled twoToneColor="#09D4AB" />}
          onClick={() => onSelectItem(record)}
        />
      ),
    },
  ];
}
